<template>
  <section class="entrar">
    <img src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/app/faixa-brilhante.png" class="efeito" />
    <video src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/app/icone-3d-animado.mp4" autoplay muted loop playsinline preload="auto"></video>
    <h1>{{ state.titulo }}</h1>
    <div class="quadro">
      <div class="ecosistema">
        <a href="https://app.levelmember.com" target="_blank">
          <Svgs nome="unicpages-icone" />
          <p>
            UNIC
            <span>PAGES</span>
          </p>
        </a>
        <a class="ativo">
          <Svgs nome="levelmember-icone" />
          <p>
            LEVEL
            <span>MEMBER</span>
          </p>
        </a>
      </div>
      <div class="titulo">
        <h2>
          LEVEL
          <span>MEMBER</span>
        </h2>
        <p>Faça login em sua conta para acessar suas áreas de membros na plataforma</p>
      </div>
      <!-- <div class="google">
        <button>
          <Svgs nome="google-colorido" />
          <p>Entrar com Google</p>
        </button>
      </div>
      <div class="divisor">
        <span></span>
        <p>ou</p>
      </div> -->
      <div class="campos">
        <Campo tipo="email" placeholder="email@email.com" completar="email" label="Seu e-mail de acesso" v-model="state.email" />
        <Campo tipo="password" placeholder="senha#123" completar="current-password" senha label="Sua senha" v-model="state.senha" @keyup.enter="entrar()" />
        <div class="esqueceu">
          <!--  @click="storeModal.abrirModal('esqueceuSenha', 'cadeado', 'Recupere a senha da sua conta')" -->
          <button>
            <p>Esqueceu sua senha? Chame no Chat</p>
            <Svgs nome="cadeado" />
          </button>
        </div>
        <BotaoPrincipal nome="Entrar na Plataforma" :disabled="state.desabilitarBotao" @click="entrar()" />
        <div class="testar">
          <p>Ainda não tem conta?</p>
          <button @click="router.push('/registrar')">Crie grátis aqui</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { inject, reactive, onMounted } from 'vue'
import { helperValidacoes } from '@helpers'
import { useRouter } from 'vue-router'
import apiAutenticacao from '@/api/levelmember/api-autenticacao'
import BotaoPrincipal from '@/components/global/elementos/BotaoPrincipal.vue'
import Campo from '@/components/global/elementos/Campo.vue'
import Svgs from '@svgs'

const emitter = inject('emitter')
const router = useRouter()

const state = reactive({
  email: '',
  senha: '',
  desabilitarBotao: false,
  frase: 'O melhor construtor de Área de Membros',
  titulo: ''
})

const escreverTexto = () => {
  let i = 0
  const intervalo = setInterval(() => {
    if (i < state.frase.length) {
      state.titulo += state.frase[i]
      i++
    } else {
      clearInterval(intervalo)
    }
  }, 100)
}

function validarDados() {
  let mensagem
  if (!state.email || !state.senha) mensagem = 'Por favor preencha todos os campos'
  else if (!helperValidacoes.email(state.email)) mensagem = 'Email digitado está no formato incorreto'
  else return true

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: mensagem })
  return false
}

async function entrar() {
  if (!validarDados()) return

  const payload = {
    email: state.email,
    senha: state.senha
  }

  try {
    state.desabilitarBotao = true
    const resp = await apiAutenticacao.entrar(payload)
    localStorage.setItem('levelmember-produtor-access-token', resp.token)
    setTimeout(() => window.location.assign('/inicio'), 300)
  } catch (error) {
    state.desabilitarBotao = false
    emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: error })
  }
}

onMounted(() => {
  setTimeout(() => {
    escreverTexto()
  }, 2000)
})
</script>

<style scoped>
section.entrar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-color: var(--cor-preto);
  position: relative;
  overflow: hidden;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
}
img.efeito {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  max-width: 1000px;
  pointer-events: none;
}
video {
  position: absolute;
  width: 100%;
  max-width: 550px;
  left: 80px;
  top: 40px;
  z-index: 1;
  background-color: var(--cor-preto);
  border: 10px solid var(--cor-preto);
  pointer-events: none;
}
h1 {
  font-family: var(--semibold);
  font-size: var(--f6);
  color: transparent;
  background: linear-gradient(90deg, var(--degrade-texto));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  width: 100%;
  max-width: 500px;
  min-height: 170px;
  line-height: 1.2;
  position: absolute;
  bottom: 50px;
  left: 50px;
  z-index: 3;
}
.quadro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  max-width: 600px;
  height: calc(100% - 40px);
  right: 20px;
  top: 20px;
  background-color: var(--cor-escuro-t);
  border: 2px solid var(--cor-escuro-3);
  padding: 60px 0 0 0;
  border-radius: 8px;
  z-index: 3;
}
.ecosistema {
  display: flex;
  width: 100%;
  position: absolute;
  top: 0;
  border-bottom: 1px solid var(--cor-escuro-3);
}
.ecosistema a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 60px;
  background-color: transparent;
  transition: all 0.3s;
}
.ecosistema a:nth-child(2) {
  border-right: 1px solid var(--cor-escuro-3);
  border-left: 1px solid var(--cor-escuro-3);
}
.ecosistema a.ativo {
  border-radius: 10px 0 0 0;
  background-color: var(--cor-escuro-3);
  pointer-events: none;
}
.ecosistema a:hover {
  background-color: var(--cor-escuro-2);
}
.ecosistema a p {
  display: flex;
  align-items: center;
  font-family: var(--semibold);
  font-size: var(--f1);
  color: var(--cor-branco);
}
.ecosistema a p span {
  font-family: var(--extralight);
}
.ecosistema a svg {
  width: 20px;
  height: 20px;
  margin: 0 5px 0 0;
}
.titulo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.titulo h2 {
  display: flex;
  font-family: var(--semibold);
  font-size: var(--f4);
  color: var(--cor-gelo);
}
.titulo h2 span {
  font-family: var(--extralight);
}
.titulo svg {
  width: 150px;
  min-width: 150px;
  margin: 0 0 15px 0;
}
.titulo p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  line-height: 1.5;
  text-align: center;
  width: 100%;
  max-width: 300px;
  margin: 10px 0 20px 0;
}
.google {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}
.google button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  border-radius: 8px;
  width: 100%;
  background-color: var(--cor-escuro-2);
  transition: all 0.3s;
}
.google button:hover {
  background-color: var(--cor-escuro-3);
}
.google button p {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.google button svg {
  width: 15px;
  min-width: 15px;
  margin: 0 10px 0 0;
}
.divisor {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  position: relative;
  z-index: 2;
  margin: 20px 0;
}
.divisor span {
  width: 100%;
  max-width: 300px;
  height: 2px;
  background-color: var(--cor-escuro-3);
  position: absolute;
  z-index: 1;
}
.divisor p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-4);
  background-color: var(--cor-escuro-1);
  padding: 0 20px;
  z-index: 2;
}
.campos {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}
.campos .campo {
  margin: 0 0 15px 0;
}
.campos .esqueceu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 0 0 15px 0;
}
.campos .esqueceu button {
  display: flex;
  align-items: center;
  background-color: transparent;
}
.campos .esqueceu button p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.campos .esqueceu button svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-escuro-6);
  margin: 0 0 0 5px;
  transition: all 0.3s;
}
.campos .testar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 20px 0 0 0;
}
.campos .testar p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.campos .testar button {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  text-decoration: underline;
  margin: 0 0 0 5px;
  transition: all 0.3s;
}
.campos .testar button:hover {
  color: var(--cor-verde);
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.entrar {
    justify-content: center;
    align-items: flex-start;
    overflow-y: scroll;
    padding: 200px 10px 10px 10px;
  }
  img.efeito {
    left: 0;
    bottom: auto;
    top: 0;
    width: 100%;
    max-width: 100%;
  }
  video {
    max-width: 220px;
    left: 0;
    top: -20px;
    border: 5px solid #000000;
  }
  h1 {
    font-size: var(--f3);
    max-width: 170px;
    min-height: 140px;
    line-height: 1.3;
    bottom: auto;
    top: 60px;
    left: 170px;
  }
  .quadro {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    right: auto;
    top: auto;
    padding: 120px 20px 50px 20px;
  }
  .titulo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .titulo h2 {
    font-size: var(--f3);
  }
  .google button {
    padding: 20px;
  }
  .divisor {
    margin: 15px 0;
  }
  .divisor span {
    max-width: 250px;
  }
  .divisor p {
    padding: 0 15px;
  }
  .campos button.entrar {
    font-size: var(--f2);
  }
}
</style>
